import { createSlice } from '@reduxjs/toolkit';
import { format, startOfYear } from 'date-fns';

import { globalBEDateFormat } from 'common/dateFormatConfig';

// Called per mount so the default range follows the calendar year, not the import time.
const defaultFilters = () => ({
  userId: '',
  from: format(startOfYear(new Date()), globalBEDateFormat),
  to: format(new Date(), globalBEDateFormat),
  sortBy: '',
  sortOrder: 'asc',
});

const initialState = {
  rows: [],
  hasMore: false,
  loading: false,
  error: null,
  filters: defaultFilters(),
  users: [],
  purging: false,
};

const slice = createSlice({
  name: 'geoLocations',
  initialState,
  reducers: {
    filtersChanged(state, { payload }) {
      state.filters = { ...state.filters, ...payload };
    },
    fetchStarted(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSucceeded(state, { payload: { rows, hasMore, append } }) {
      state.rows = append ? state.rows.concat(rows) : rows;
      state.hasMore = hasMore;
      state.loading = false;
    },
    fetchFailed(state, { payload }) {
      state.loading = false;
      state.error = payload;
    },
    errorCleared(state) {
      state.error = null;
    },
    usersLoaded(state, { payload }) {
      state.users = payload;
    },
    purgeStarted(state) {
      state.purging = true;
    },
    purgeFinished(state) {
      state.purging = false;
    },
    reset() {
      return { ...initialState, filters: defaultFilters() };
    },
  },
});

export const geoLocationsActions = slice.actions;

export default slice.reducer;
